export const environment = {
  admNome: 'Venda Online',
  apiUrl: 'https://api.g2saude.com.br/api/cliente',
  assets: 'vitrea',
  base: 'vitrea',
  production: true,
};
